import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M12 8V4l8 8-8 8v-4H4V8z"
}), 'Forward');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/Forward.js
// module id = 3919
// module chunks = 2